import * as querystring from 'querystring';

export default function getProductUrl(
  vendorVariant: {
    id: string | number;
    productUrl?: string;
    productDetailsUrl?: string;
  },
  opts?: {
    sourceBoardId?: number | string;
    projectBoardCommission?: any;
    listId?: string;
  }
) : string {
  const url = vendorVariant.productUrl || vendorVariant.productDetailsUrl || `/products/details/${vendorVariant.id}`;

  const [base, query] = url.split('?');
  const params = querystring.parse(query || '');
  if (opts?.sourceBoardId) {
    params.board = opts.sourceBoardId.toString();
  }

  if (opts?.projectBoardCommission) {
    params.projectBoardCommission = JSON.stringify(opts.projectBoardCommission);
  }

  let formattedUrl = `${base}?${querystring.stringify(params)}`.replace(/\?$/, '');

  if (opts?.listId) {
    formattedUrl += `#plid=${opts.listId}`;
  }

  return formattedUrl;
}
